import type { CampaignDraftPostItem } from '@/entities/campaign';
import { useMemo } from 'react';

import {
  type CampaignCreateIssue,
  getPostRowError,
} from '../../../../hooks';

type UseCampaignPostValidationArgs = {
  postItems: CampaignDraftPostItem[];
};

export type CampaignPostValidation = ReturnType<typeof useCampaignPostValidation>;

export function useCampaignPostValidation({ postItems }: UseCampaignPostValidationArgs) {
  const draftPostItems = useMemo(
    () => postItems.filter((item) => item.postUrl.trim().length > 0),
    [postItems],
  );

  const postIssues = useMemo(
    () =>
      draftPostItems
        .map((item) => ({
          rowId: item.id,
          message: getPostRowError(item),
        }))
        .filter((item): item is CampaignCreateIssue => Boolean(item.message)),
    [draftPostItems],
  );

  return {
    draftPostItems,
    isReady: postIssues.length === 0,
    postIssues,
  };
}
